import React, { FC } from 'react';
import { Form, Modal } from 'react-bootstrap';
import styles from './EditOrganizationDocumentModal.module.css';
import { Button } from '../../atoms';
import cn from 'classnames';
import { BuyerDocumentResponseDto } from '../../../store/buyerAPI/buyer/dto/response/buyer-document-response.dto';
import TranslationOrganism from '../TranslationOrganism';
import { LocalesLanguagesConstants } from '../../../locales/locales';
import { PromiseSettledResult } from '../../../utils/types/types';

interface EditOrganizationDocumentModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  document: BuyerDocumentResponseDto;
  handleOnChange: (document: BuyerDocumentResponseDto) => void;
  handleEdit: (document: BuyerDocumentResponseDto) => void;
  setLanguage: React.Dispatch<React.SetStateAction<LocalesLanguagesConstants>>;
  selectedLanguage: LocalesLanguagesConstants;
  fromLanguage: LocalesLanguagesConstants;
  setFromLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  toLanguage: LocalesLanguagesConstants;
  setToLanguage: React.Dispatch<
    React.SetStateAction<LocalesLanguagesConstants>
  >;
  generateTranslation: () => Promise<void>;
  generateAllTranslations: () => Promise<PromiseSettledResult<void>[]>;
}

const EditOrganizationDocumentModal: FC<EditOrganizationDocumentModalProps> = ({
  show,
  setShow,
  document,
  handleOnChange,
  handleEdit,
  setLanguage,
  selectedLanguage,
  fromLanguage,
  setFromLanguage,
  toLanguage,
  setToLanguage,
  generateTranslation,
  generateAllTranslations,
}) => {
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      className={cn(styles.wrapper)}
    >
      <div className={cn(styles.modal)}>
        <Modal.Body className={cn(styles.modalBody)}>
          <Form.Group className="mb-3">
            <TranslationOrganism
              setLanguage={setLanguage}
              selectedLanguage={selectedLanguage}
              fromLanguage={fromLanguage}
              setFromLanguage={setFromLanguage}
              toLanguage={toLanguage}
              setToLanguage={setToLanguage}
              generateTranslation={generateTranslation}
              generateAllTranslations={generateAllTranslations}
            />
            <Form.Label>Document Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter document name"
              onChange={(e) =>
                handleOnChange({ ...document, name: e.target.value })
              }
              value={document.name ?? ''}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Filename</Form.Label>
            <Form.Label className={cn(styles.fileNameWrapper)}>
              {document.file}
            </Form.Label>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer className={cn(styles.modalButtons)}>
          <Button
            className={cn(styles.button)}
            variant="dark"
            onClick={() => handleEdit(document)}
          >
            Save
          </Button>
          <Button
            className={cn(styles.cancelButton)}
            variant="light"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </div>
    </Modal>
  );
};

export default EditOrganizationDocumentModal;
